<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab tabid="tab-accounts" :first="true">
        <i class="far fa-user-circle"></i> Accounts
      </Tab>
      <Tab tabid="tab-activity">
        <i class="far fa-clipboard-list"></i> Recent Activity
      </Tab>
    </template>
    <template v-slot:tabcontent>

      <TabPage :first="true" tabid="tab-accounts">
        <div class="float-right">
          <ActionButton type="new" @click="onboardNewAccount"> Onboard New Account</ActionButton>
        </div>
        <ContentTitle>Accounts</ContentTitle>
        <StaticDataTable class="static-table-list">
          <template v-slot:header>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Owner Email</th>
              <th>Users</th>
              <th>State</th>
              <th>Country</th>
              <th>Activated</th>
              <th>Subscription</th>
              <th>Created Date</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="account of systemAccountList" :key="account.id">
              <td class="font-weight-bold">
                <router-link :to="`/developer/accounts/${account.id}`">{{account.id}}</router-link>
              </td>
              <td class="font-weight-bold">
                <router-link :to="`/developer/accounts/${account.id}`">{{account.companyName}}</router-link>
              </td>
              <td>{{account.ownerEmail}}</td>
              <td>{{account.userCount}}</td>
              <td>{{account.stateCode}}</td>
              <td>{{account.countryCode}}</td>
              <td :class="[account.isAccountActivated ? 'status-active' : 'status-inactive']">{{formatBoolean(account.isAccountActivated)}}</td>              
              <td>
                <div v-if="account.activeSub" class="status-active">Valid to {{formatDate(account.activeSubExpiry)}}</div>
                <div v-if="!account.activeSub" class="status-inactive">None</div>
              </td>
              <td>{{formatDateTime(account.createdAt)}}</td>
            </tr>
          </template>
        </StaticDataTable>
      </TabPage>

      <TabPage tabid="tab-activity">
        <ContentTitle>Recent Activity Logs</ContentTitle>

        <StaticDataTable class="static-table-list">
          <template v-slot:header>
            <tr>
              <th>Type</th>
              <th>Message</th>
              <th>Details</th>
              <th>LinkType</th>
              <th>LinkId</th>
              <th>User</th>
              <th>Account</th>
              <th>Date</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="activityItem of activityItemList" :key="activityItem.id">
              <td class="font-weight-bold">{{activityItem.activityType}}</td>
              <td>{{activityItem.message}}</td>
              <td>{{activityItem.extraDetails}}</td>
              <td>{{activityItem.linkType}}</td>
              <td>{{activityItem.linkId}}</td>
              <td>{{activityItem.userName}}</td>
              <td>{{activityItem.accountCompanyName}}</td>
              <td>{{formatDateTime(activityItem.createdAt)}}</td>
            </tr>
          </template>
        </StaticDataTable>
      </TabPage>

    </template>
  </TabbedBox>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'
import form from '@/mixins/form'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import OnboardAccountDialog from '@/modules/developer/views/onboardAccountDialog'
import Popover from '@/components/popover'

export default {
  name: 'DeveloperAccountList',
  mixins: [form],
  components: {
    ReportFilterPopover,
    ReportDateRangeSelect,
    Popover
  },
  data() {
    return {
      activityItemList: [],
      systemAccountList: [],
    }
  },
  mounted() {
    this.$apiService.developerService.developerGetSystemInfo()
    .then(response => {
      this.$data.systemAccountList = response.data.accountList
    })
    this.$apiService.developerService.developerGetRecentActivityItemList()
    .then(response => {
      this.$data.activityItemList = response.data
    })
  },
  beforeDestroy () {
  },
  computed: {
    
  },
  methods: {
    reloadAccountList() {
      this.$apiService.developerService.developerGetSystemInfo()
      .then(response => {
        this.$data.systemAccountList = response.data.accountList
      })
    },    
    onboardNewAccount() {
      this.displayModal(OnboardAccountDialog)
      .then((success) => {
        if(success) {
          this.successToast('Account Created')
          this.reloadAccountList()
        }
      })
    }
  }
}

</script>